import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { darkPurple, lightBlack } from '../../../../../mainTheme';

export const StatusMessage = ({
  icon,
  title = 'Added successfully!',
  message = '',
  onClose,
  primaryButtonText = 'OK',
}: {
  icon: React.ReactNode;
  title?: string;
  message?: string;
  onClose: () => void;
  primaryButtonText?: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      {icon}

      <Typography
        sx={{
          fontWeight: 500,
          fontSize: '22px',
          lineHeight: '30px',
          letterSpacing: '0.36px',
          color: darkPurple,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontWeight: 500,
          fontSize: '16px',
          lineHeight: '22px',
          letterSpacing: '0.2px',
          color: lightBlack,
        }}
      >
        {message}
      </Typography>

      <Button
        variant="contained"
        color="secondary"
        onClick={onClose}
        sx={{
          mt: '40px',
          width: '100%',
          height: '44px',
          fontSize: '14px',
          fontWeight: 700,
          lineHeight: '18px',
          letterSpacing: '0.2px',
        }}
      >
        {primaryButtonText}
      </Button>
    </Box>
  );
};
